/** Represents a boundary point as defined in the DOM Level 2 spec. */
// https://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#td-boundarypoint
export interface BoundaryPoint {
  container: Node;
  offset: number;
}

export function createRangeWithBoundaryPoints(
  document: Document,
  start: BoundaryPoint,
  end: BoundaryPoint,
): Range {
  const range = document.createRange();
  range.setStart(start.container, start.offset);
  range.setEnd(end.container, end.offset);
  return range;
}
